import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const PIXEL_ID = '1983478698863427';

const initFacebookPixel = () => {
  if (typeof window === 'undefined') return;
  if (window.fbq) {
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
    return;
  }
  (function(f,b,e,v,n,t,s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  if (window.fbq) {
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
  }
};

const scheduleFacebookPixel = () => {
  if (typeof window === 'undefined') return;
  const run = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => initFacebookPixel(), { timeout: 3000 });
    } else {
      setTimeout(() => initFacebookPixel(), 1500);
    }
  };

  if (document.readyState === 'complete') {
    run();
    return;
  }

  window.addEventListener('load', run, { once: true });
};

scheduleFacebookPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
